import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { FeatureFlags } from '@/helpers/featureFlags'

export const useIsPremierBuyer = (): boolean => {
  return useFlag(FeatureFlags.PREMIER_BUYER)
}
